<template>
  <div class="tab-pane fade" id="sos-cross-content" role="tabpanel" aria-labelledby="sos-cross-content-tab">
    <div class="container-fluid">
      <form class="row g-3">

        <div class=" col-sm-12 col-md-6">
          <label for="inputEmail4" class="form-label">風景區</label><br>
          <select id="selectArea" class="selectpicker" v-model.number="selectScenicAreas" multiple>
            <!-- <option :value="selectAll">全部</option> -->
            <option v-for="(list, index) in sosScenicArea" :key="index" :value="list">{{ list.name }}</option>
          </select>
        </div>
        
        <div class="col-md-3">
          <label for="inputEmail4" class="form-label">狀態</label>
          <select class="form-control" id="SensorSN" name="SensorSN" v-model.number="selectDismissStatus">
            <option selected="selected" value="-1">全部</option>
            <option value="1">已處理</option>
            <option value="0">未解除</option>
          </select>
        </div>
        
        <div class="col-md-3">
          <label for="inputEmail4" class="form-label">警報內容</label>
          <select class="form-control" id="SensorSN" name="SensorSN" v-model.number="selectDismissContent">
            <option selected="selected" :value="CONST.SOS_DISSMISS_CONTENT.ALL">{{ CONST.SOS_DISSMISS_CONTENT.ALL }}
            </option>
            <option :value="CONST.SOS_DISSMISS_CONTENT.MISTAKE">{{ CONST.SOS_DISSMISS_CONTENT.MISTAKE }}</option>
            <option :value="CONST.SOS_DISSMISS_CONTENT.TEST">{{ CONST.SOS_DISSMISS_CONTENT.TEST }}</option>
            <option :value="CONST.SOS_DISSMISS_CONTENT.UNWELL">{{ CONST.SOS_DISSMISS_CONTENT.UNWELL }}</option>
            <option :value="CONST.SOS_DISSMISS_CONTENT.INJURY">{{ CONST.SOS_DISSMISS_CONTENT.INJURY }}</option>
            <option :value="CONST.SOS_DISSMISS_CONTENT.OTHER">{{ CONST.SOS_DISSMISS_CONTENT.OTHER}}</option>
            <!-- <option :value="CONST.SOS_DISSMISS_CONTENT.ALERT">{{ CONST.SOS_DISSMISS_CONTENT.ALERT }}</option> -->
          </select>
        </div>
        
        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-3">
          <label for="inputEmail4" class="form-label">時段</label>
          <select class="form-control" id="SensorSN" name="SensorSN" v-model.number="selectTimePeriod">
            <option selected="selected" value="-1">全部</option>
            <option value="1">日間</option>
            <option value="0">夜間</option>
          </select>
        </div>


        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk"
            :disabled="isWaitResult">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV"
            :disabled="isWaitResult">
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">跨區比較</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col order-2 order-md-1">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="crossSos" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th width="5%">#</th>
                    <th>通報時間</th>
                    <th>風景區</th>
                    <th>時段</th>
                    <th>警報數量</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in emergencyEventList" :key="key" :class="tableCenterStyle">
                    <td>{{ key + 1 }}</td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.scenicAreaName }}</td>
                    <!-- <td>{{ item.placeName }}</td> -->
                    <td>{{ item.timePeriodContent }}</td>
                    <!-- <td>{{ item.dismissContent }}</td> -->
                    <td>{{ item.count }}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div class="col order-1  order-md-2">
          <div id="realAreaCarChart">
            <apexchart type="bar" height="200" :options="chartSetting" :series="chartData"></apexchart>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from 'vuex'
import VueApexCharts from "vue-apexcharts";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'
import ApexchartObject from '../../utils/apexchartObject/searchSos'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      CONST: CONST,
      selectAll: CONST.MULTI_SELECT_ALL,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      selectScenicAreas: [],
      selectDismissStatus: -1,
      selectDismissContent: CONST.SOS_DISSMISS_CONTENT.ALL,
      emergencyEventList: [],
      selectedEvent: null,
      dismissedContent: '',
      inputContent: '',

      chartData: [],
      chartSetting: { ...ApexchartObject.crossRegionSos },

      selectTimePeriod: -1, // -1 全部， 1日間, 0夜間
      isWaitResult: false,
      maxSelectTime: Utils.getLastestTime(),
      sosScenicArea: null,
    };
  },

  watch: {
    scenicAreaList() {
      this.updateScenicAreaList()
    },

    // selectScenicAreas() {
    //   console.log('this.selectScenicAreas', this.selectScenicAreas)
    //   if (this.selectScenicAreas[0].value === CONST.MULTI_SELECT_ALL && this.selectScenicAreas.length === 1) {
    //     $('#selectArea').selectpicker('selectAll');
    //     // $('#selectActivities').selectpicker('deselectAll');

    //   }
    // }
    selectScenicAreas: {
     handler(newValue, oldValue){
      // console.log("new",newValue)
      // console.log("old",oldValue)
      // console.log("a",newValue[0].value)
      // console.log("b",oldValue.length)
      
      if(newValue.length > 0 && oldValue.length < 1){
  
           if(newValue[0].value === CONST.MULTI_SELECT_ALL){
              //表示若已有選擇其他景區，再選擇全部的情況
              $('#selectArea').selectpicker('selectAll');
          }
      }

      if(newValue.length > 0 && oldValue.length > 0){
          if(newValue[0].value !== CONST.MULTI_SELECT_ALL&& oldValue[0].value === CONST.MULTI_SELECT_ALL){
          //表示取消全部選擇的情況
            $('#selectArea').selectpicker('deselectAll');
            this.selectScenicAreas = [];
          }
          if(newValue[0].value === CONST.MULTI_SELECT_ALL &&  oldValue[0].value !== CONST.MULTI_SELECT_ALL){
          //表示若已有選擇其他景區，再選擇全部的情況
            $('#selectArea').selectpicker('selectAll');
          }

          if(oldValue[0].value === CONST.MULTI_SELECT_ALL && newValue.length < oldValue.length ){
            //表示選擇全部，但是未全選
            //表示從全選狀態離開，產生非全選的狀態，移除陣列this.selectScenicAreas的[0](selectAll)
            this.selectScenicAreas.shift();
          }

        }
      }
    }

  },



  computed: {
    // ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),
    // ...mapGetters("scenicArea", { myScenicAreaList: "getMyScenicArea" }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),

    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },

  },
  methods: {
    updateScenicAreaList() {
      if(this.scenicAreaList.length === 0) {
        return 
      }
      
      // $('#selectArea').selectpicker('destroy');
      this.sosScenicArea = this.scenicAreaList.filter(
        (s) =>
          s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.SOS
      )
      this.sosScenicArea = [{ value: CONST.MULTI_SELECT_ALL, name: "全部" }].concat(this.sosScenicArea)
      console.log("this.sosScenicArea", this.sosScenicArea)
      $('#selectArea').selectpicker({
        noneSelectedText: '請選擇'
      })
      this.$nextTick(function () { $('#selectArea').selectpicker('refresh'); });
    },

    async queryCSV() {
      this.isWaitCCTVList = true
      if (this.selectScenicAreas.length === 0 || this.selectScenicAreas[0].value === CONST.MULTI_SELECT_ALL)
        this.selectScenicAreas = this.sosScenicArea // 預設全選

      let dataList = []
      if (this.selectScenicAreas.length === 0 || this.selectScenicAreas[0].value === CONST.MULTI_SELECT_ALL) {
        dataList = await this.searchElk(-1)
      } else {
        for (let i = 0; i < this.selectScenicAreas.length; i++) {
          const data = await await this.searchElk(this.selectScenicAreas[i].id);
          dataList = dataList.concat(data)
        }
      }

      const emergencyEventList = this.countByScienicArea(dataList)
      if (Utils.isEmptyObject(emergencyEventList)) {
        alert('此搜尋沒有資料')
        return
      }

      const csvContent = [['通報時間', '風景區', '時段', '狀態', '警報類型', '警報數量']]

      emergencyEventList.forEach(item => {
        const row = []
        row.push(item.date)
        row.push(item.scenicAreaName)
        row.push(item.timePeriodContent)
        row.push(item.dismissStatus)
        row.push(this.selectDismissContent)
        row.push(item.count)

        csvContent.push(row)
      })

      const fileName = `景區_緊急求救_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}.csv`
      exportCSV.genCSVFile(csvContent, fileName)
      this.isWaitCCTVList = false
    },

    async queryElk() {
      this.isWaitCCTVList = true

      let dataList = []
      if (this.selectScenicAreas.length === 0 || this.selectScenicAreas[0].value === CONST.MULTI_SELECT_ALL) {
        dataList = await this.searchElk(-1)
      } else {
        for (let i = 0; i < this.selectScenicAreas.length; i++) {
          const data = await await this.searchElk(this.selectScenicAreas[i].id);
          dataList = dataList.concat(data)
        }
      }

      this.emergencyEventList = this.countByScienicArea(dataList)
      this.setChartData(this.emergencyEventList)
      this.updateTable()
      this.isWaitCCTVList = false
    },

    async searchElk(id) {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert('結束時間不可以小於開始時間')
        return
      }

      const condition = {
        startTime: moment(this.startTime).startOf('minute').format(),
        endTime: moment(this.endTime).startOf('minute').format(),
        scenicAreaId: id,
        dismissStatus: this.selectDismissStatus
      }

      await this.$store.dispatch('emergencyEvent/getEmergencyEvents', condition)
      const emergencyEventList = this.$store.getters['emergencyEvent/getEvents']
      const timePeriod = this.filterTimePeriod(emergencyEventList)
      return this.filterDismissContent(timePeriod)
    },

    filterDismissContent(emergencyEventList) {
      if (Utils.isEmptyObject(emergencyEventList)) {
        return []
      }

      let result = []
      switch (this.selectDismissContent) {
        case CONST.SOS_DISSMISS_CONTENT.ALL:
          result = emergencyEventList
          break

        case CONST.SOS_DISSMISS_CONTENT.MISTAKE:
          result = emergencyEventList.filter(item => item.dismissContent === CONST.SOS_DISSMISS_CONTENT.MISTAKE)
          break

        case CONST.SOS_DISSMISS_CONTENT.TEST:
         result = emergencyEventList.filter(item => 
            item.dismissContent === CONST.SOS_DISSMISS_CONTENT.TEST || 
            item.dismissContent === CONST.SOS_DISSMISS_CONTENT.TEST_2
          );
          break;

        case CONST.SOS_DISSMISS_CONTENT.UNWELL:
          result = emergencyEventList.filter(item => item.dismissContent === CONST.SOS_DISSMISS_CONTENT.UNWELL)
          break;
        
        case CONST.SOS_DISSMISS_CONTENT.INJURY:
          result = emergencyEventList.filter(item => item.dismissContent === CONST.SOS_DISSMISS_CONTENT.INJURY)
          break;
          
       case CONST.SOS_DISSMISS_CONTENT.OTHER:
          const excludedTypes = [
            CONST.SOS_DISSMISS_CONTENT.MISTAKE,
            CONST.SOS_DISSMISS_CONTENT.TEST,
            CONST.SOS_DISSMISS_CONTENT.TEST_2,
            CONST.SOS_DISSMISS_CONTENT.UNWELL,
            CONST.SOS_DISSMISS_CONTENT.INJURY
          ]
         // 以上警報內容以外的警報 (其他)
          result = emergencyEventList.filter(item => !excludedTypes.includes(item.dismissContent))
          break;
      }

      return result

    },

    filterTimePeriod(emergencyEventList) {
      if (Utils.isEmptyObject(emergencyEventList)) {
        return []
      }

      //設定時段
      emergencyEventList.forEach(item => {
        const momentTime = moment(item.eventTime)
        const momentDate = momentTime.format('YYYY/MM/DD')
        let isDayTime = momentTime.isBetween(moment(`${momentDate} 08:00`, 'YYYY/MM/DD hh:mm'), moment(`${momentDate} 17:30`, 'YYYY/MM/DD hh:mm'))
        item.timePeriod = isDayTime ? 1 : 0
        item.timePeriodContent = isDayTime ? CONST.SOS_TIME_PERIOD.DAY_TIME : CONST.SOS_TIME_PERIOD.NIGHT
      })


      if (this.selectTimePeriod === -1) {
        return emergencyEventList
      }

      return emergencyEventList.filter(item => item.timePeriod === this.selectTimePeriod)
    },

    countByScienicArea(dataList) {
      if (Utils.isEmptyObject(dataList))
        return []

      const scienicAreaGroupBy = Utils.arrayGroupBy(dataList, CONST.SCENIC_AREA_NAME, 'sosList')
      console.log('scienicAreaGroupBy', scienicAreaGroupBy)

      const result = []
      const date = `${moment(this.startTime).format('YYYY/MM/DD hh:mm')} ~ ${moment(this.endTime).format('YYYY/MM/DD hh:mm')}`
      const period = this.selectTimePeriod === -1 ? '全部' :
        this.selectTimePeriod === 1 ? CONST.SOS_TIME_PERIOD.DAY_TIME : CONST.SOS_TIME_PERIOD.NIGHT
      const status = this.selectDismissStatus === -1 ? '全部' :
        this.selectDismissStatus === 1 ? '已處理' : '未處理'

      scienicAreaGroupBy.forEach(scienicArea => {
        const data = {
          date: date,
          timePeriodContent: period,
          dismissStatus: status,
          scenicAreaName: scienicArea[CONST.SCENIC_AREA_NAME],
          count: scienicArea.sosList.length
        }

        result.push(data)
      })

      return result
    },

    setChartData(dataList) {
      if (Utils.isEmptyObject(dataList)) {
        this.chartData = [],
          this.chartSetting = ApexchartObject.crossRegionSos
        return
      }


      const countSeries = dataList.map((d, i) => {
        return d.count
      })

      this.chartData = []
      this.chartData.push({ name: '警報次數', data: countSeries })

      const xaxisCategories = dataList.map((d, i) => {
        return d.scenicAreaName
      })
      this.chartSetting.subtitle.text="呈現查詢區間各個景區所有的警報總數";
      this.chartSetting.subtitle.align="center";

      let chartSetting = { ...this.chartSetting }
      chartSetting = { ...chartSetting, ...{ xaxis: { categories: xaxisCategories } } } //https://github.com/apexcharts/vue-apexcharts/issues/74#issuecomment-472717678
      this.chartSetting = { ...chartSetting } // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    },

    getTime: function (time) {
      if (Utils.isEmptyObject(time)) {
        return '-'
      }
      return moment(time).format('YYYY/MM/DD HH:mm')
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    initTable: function () {
      this.table = $("#crossSos").DataTable({
        aoColumns: [
          ...new Array($("#crossSos th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: '/json/dataTableZHTW.json'
        },
        "pageLength": 25
      });
    },
    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable()
    this.updateScenicAreaList()
    // $('#selectArea').selectpicker({
    //     noneSelectedText: '請選擇'
    // })

  }
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

tbody>tr>td {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

/* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
}

/* table不超過div */</style>
